<template>
  <div class="avatar-container">
    <div class="avatar-wrapper">
      <div class="avatar-image" :style="backgroundImage"></div>

      <div class="avatar-text-wrapper">
        <div class="avatar-text">
          <span class="d-inline-block text-block"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    backgroundImage() {
      const avatarURL = require("@/assets/img/anatomy/avatar.png");

      return `background-image: url('${avatarURL}')`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.avatar-container {
  flex: 0 0 auto;
  width: 66px;

  @media only screen and (min-device-width: 768px) {
    width: 190px;
  }
}

.avatar-wrapper {
  display: flex;
  width: 100%;
}

.avatar-text-wrapper {
  display: none;

  @media only screen and (min-device-width: 768px) {
    display: flex;
    align-items: center;
  }
}

.avatar-text {
  .text-block {
    background-color: #e1e1e1;
    width: 50px;
    height: 10px;
  }
}

.avatar-image {
  height: 49px;
  width: 48px;
  margin-right: 10px;
  background-color: #030c22;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  @media only screen and (min-device-width: 768px) {
    height: 62px;
    width: 62px;
    border: 1px solid #030c22;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/capsuleAnatomy/CapsuleAvatar.vue